module.exports = __webpack_public_path__ + "img/after_ski_nomargin.f7067aa5.jpg";